import React from 'react'
import reactStamp from 'react-stamp'
import EditPatientInfoDialog from './EditInfoDialog';
import './home.css'

export default reactStamp(React).compose({

    render() {
        let classNames = '';

        if (this.props.single) {
            classNames = "patient-info-container single-info";
        } else {
            classNames = "patient-info-container";
        }
        let {patientNameGiven, patientNameFamily, single, ...editable} = this.props;

        return (
            <div className={classNames}>
                <h1 className="name-label">{patientNameGiven + " " + patientNameFamily}</h1>
                <p className="address-label">{this.props.patientAddressLine}</p>
                <p className="address-label">{this.props.patientAddressCity}</p>
                <p className="address-label">{this.props.patientAddressState}</p>
                <p className="address-label">{this.props.patientAddressPostalCode}</p>
                <p className="address-label">{this.props.patientAddressCountry}</p>
                <p className="address-label">{this.props.patientPhone}</p>
                <EditPatientInfoDialog {...editable}/>
            </div>
        )

    }

});


/** WEBPACK FOOTER **
 ** ./src/app/components/Home/PatientInfo.js
 **/